// Every route of this WP (docs/v3/COVERAGE.md). screen(n) without a page = the
// "being built" placeholder; replace it with screen(n, page(...)) when the page exists.
import { extra, page, screen, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  // 4. Activities
  screen(39, page(() => import("./pages/ActivitiesPage"), "ActivitiesPage")),
  screen(40, page(() => import("./pages/NewActivityPage"), "NewActivityPage")),
  screen(41, page(() => import("./pages/ImportLogframePage"), "ImportLogframePage")),
  screen([42, 43, 44], page(() => import("./pages/CalendarPage"), "CalendarPage")),
  screen(45, page(() => import("./pages/MeetingsPage"), "MeetingsPage")),
  screen(47, page(() => import("./pages/LogMeetingPage"), "LogMeetingPage")),
  // One path for a meeting (#46) and a steering committee (#48): the meeting's kind decides.
  screen([46, 48], page(() => import("./pages/MeetingRecordPage"), "MeetingRecordPage")),
  screen(49, page(() => import("./pages/ScPapersPage"), "ScPapersPage")),
  screen(50, page(() => import("./pages/ScMinutesPage"), "ScMinutesPage")),
  // 4b. Deliverable and mission. One path for Event (#51, WP events), Deliverable and Mission:
  // this page picks the right one by the activity's type.
  screen([63, 51, 66], page(() => import("./pages/ActivityRecordPage"), "ActivityRecordPage")),
  screen(64, page(() => import("./pages/RequestChangesPage"), "RequestChangesPage")),
  screen(65, page(() => import("./pages/ApproveDraftPage"), "ApproveDraftPage")),
  screen(67, page(() => import("./pages/MissionReportPage"), "MissionReportPage")),
  // The same mission report for the assigned expert, in the portal shell.
  extra("/portal/activities/:id/report", page(() => import("./pages/MissionReportPage"), "PortalMissionReportPage")),
];
